import { gql } from '@apollo/client';

export const SAVE_DOCUMENT_TYPE_ALLOWED_STATE = gql`
  mutation saveDocumentTypeAllowedState($allowedState: SaveAllowedStateInput!) {
    saveDocumentTypeAllowedState(allowedState: $allowedState) {
      commandId
    }
  }
`;
